import { useIntentionalSignOut } from '@/hooks/useIntentionalSignOut';

export function NoAccessPage() {
  const signOut = useIntentionalSignOut();

  return (
    <div className="login-page">
      {signOut.dialog}
      <svg
        aria-hidden="true"
        style={{ width: 48, height: 48, color: 'var(--color-text-muted)', marginBottom: 'var(--space-4)' }}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>

      <h1 className="login-title">No access</h1>
      <p className="login-subtitle" style={{ maxWidth: 340 }}>
        This account has no Alturex Work access. Ask an admin to invite you from Ayrical.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-3)', width: '100%', maxWidth: 320, marginTop: 'var(--space-4)' }}>
        <button
          type="button"
          className="login-btn"
          onClick={() => { void signOut.requestSignOut(); }}
          disabled={signOut.isPending}
          style={{ textAlign: 'center' }}
        >
          Sign in with a different account
        </button>
      </div>
    </div>
  );
}
